<template>
    <div class="kustomer-header" style="padding: 8px 0px 4px !important;">
        <div class="kustomer-logo">
            <slot name="logo"></slot>
        </div>
    </div>
</template>

<script>
export default {}
</script>
